module.exports = __webpack_public_path__ + "static/img/img_o1.472364bc.png";